import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-end mx-2"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center my-3" }
const _hoisted_3 = ["selected", "value"]
const _hoisted_4 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_5 = { class: "clients-table table table-hover m-0" }
const _hoisted_6 = {
  key: 0,
  class: "bg-light text-dark"
}
const _hoisted_7 = {
  key: 3,
  class: "d-flex justify-content-center mt-3"
}
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = {
  class: "pagination justify-content-center",
  style: {}
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  class: "text-center col-md-12",
  style: {}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showPagination && _ctx.items.length >0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "fw-semibold me-2" }, "Records:", -1)),
            _withDirectives(_createElementVNode("select", {
              name: "limit",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemsPerPage) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPerPageOptions, (option, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  selected: option === _ctx.itemsPerPage,
                  key: index,
                  value: option
                }, _toDisplayString(option), 9, _hoisted_3))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.itemsPerPage]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.slots.rows)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            (_ctx.slots.header)
              ? (_openBlock(), _createElementBlock("thead", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "header")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tbody", null, [
              _renderSlot(_ctx.$slots, "rows", { pageItems: _ctx.pageItems })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.slots.noItems && _ctx.pageItems.length === 0)
      ? _renderSlot(_ctx.$slots, "noItems", { key: 2 })
      : _createCommentVNode("", true),
    (_ctx.showPagination && _ctx.items.length >0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("nav", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", {'disabled':_ctx.currentPage === 0}])
              }, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToFirstPage && _ctx.goToFirstPage(...args))),
                  disabled: _ctx.currentPage === 0,
                  class: "page-link"
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "fa fa-chevron-circle-left" }, null, -1)
                ]), 8, _hoisted_10)
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", {'disabled':_ctx.currentPage === 0}])
              }, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToPrevPage && _ctx.goToPrevPage(...args))),
                  disabled: _ctx.currentPage === 0,
                  class: "page-link"
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
                ]), 8, _hoisted_11)
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastPage, (num) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["page-item", {'active':_ctx.currentPage+1 === num}]),
                  key: num
                }, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.goToPage(num)),
                    class: "page-link"
                  }, _toDisplayString(num), 9, _hoisted_12)
                ], 2))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", {'disabled':_ctx.currentPage+1 === _ctx.lastPage}])
              }, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToNextPage && _ctx.goToNextPage(...args))),
                  disabled: _ctx.currentPage+1 === _ctx.lastPage,
                  class: "page-link"
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
                ]), 8, _hoisted_13)
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", {'disabled':_ctx.currentPage+1 === _ctx.lastPage}])
              }, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToLastPage && _ctx.goToLastPage(...args))),
                  disabled: _ctx.currentPage+1 === _ctx.lastPage,
                  class: "page-link"
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "fa fa-chevron-circle-right" }, null, -1)
                ]), 8, _hoisted_14)
              ], 2)
            ]),
            _createElementVNode("p", _hoisted_15, "Showing " + _toDisplayString(_ctx.start+1) + " to " + _toDisplayString(_ctx.end) + " of " + _toDisplayString(_ctx.items.length) + " records.", 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}